import Vue from 'vue'
import axios from '../../backend/vue-axios/axios'
import { router } from '@/router'
import { occupationListFromEntity, createNewOccupation,
  updateOccupation, deleteOccupation, getDestroyOccupationPermission,
  changeOccupationActiveStatus, getDeactivateOccupationPermission,
} from '@/backend/occupations'
import store from '@/store'
import i18n from '../../lang'

const SET_OCCUPATION_LIST   = 'SET_OCCUPATION_LIST';

const state = {
  occupationList: [],
}

export const mutations = {
  [SET_OCCUPATION_LIST] (state, occupations) {
    state.occupationList = occupations
  }
}

export const actions = {
  loadList({ commit }, entityID) {
    return occupationListFromEntity(entityID)
    .then( (response) => {
      var occupationList = response.data
      commit(SET_OCCUPATION_LIST, occupationList)
      occupationList.length === 0 ? store.dispatch('noData/enable') : store.dispatch('noData/disable')
    }).catch((error) => {
        store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    });
  },

  setList( { commit }, occupations) {
    commit(SET_OCCUPATION_LIST, occupations)

    if(occupations.length === 0) {
      store.dispatch('noData/enable')
    } else {
      store.dispatch('noData/disable')
    }
  },

  create({ commit, dispatch }, occupation) {
    return new Promise((resolve, reject) => {
      createNewOccupation(occupation)
      .then(response => {
        dispatch('loadList', occupation.entity_id)
        dispatch('noData/disable', null, { root:true })
        var message = {type: 'success', content: i18n.t('messages.create_success',
          { 'resource': i18n.t('resources.occupation'), 'name': occupation.name }) }
        dispatch('message/enable', message, { root:true })

        resolve(response.data)
      })
      .catch(err => {
        dispatch('message/enable', { type: 'danger', content: err.response.data.error }, { root:true })

        reject(err.response)
      })
    })
  },

  update({ commit, dispatch }, occupation) {
    return updateOccupation(occupation)
    .then(response => {
      dispatch('loadList', occupation.entity_id)
      var message = {type: 'success', content: i18n.t('messages.update_success',
        { 'resource': i18n.t('resources.occupation'), 'name': occupation.name })}
      dispatch('message/enable', message, { root:true })
      return { updated: true }
    })
    .catch(error => {
      var message = {type: 'danger', content: error.response.data.error}
      dispatch('message/enable', message, { root:true })
      return { updated: false }
    })
  },

  changeActiveStatus({ commit, dispatch }, occupation) {
    return changeOccupationActiveStatus(occupation.id, { entity_id: occupation.entity_id, active: occupation.active })
    .then(response => {
      dispatch('loadList', occupation.entity_id)
    }).
    catch(error => {
      dispatch('loadList', occupation.entity_id)
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },

  delete({ commit, dispatch }, occupation) {
    return deleteOccupation(occupation)
    .then( response => {
      dispatch('loadList', occupation.entity_id)
      var message = { type: 'success', content: i18n.t('messages.delete_success',
        { 'resource': i18n.t('resources.occupation'), 'name': occupation.name }) }
      dispatch('message/enable', message, { root:true })
    })
    .catch( error => {
      var message = { type: 'danger', content: i18n.t('messages.delete_failure',
        { 'resource': i18n.t('resources.occupation'), 'name': occupation.name }) }
      dispatch('message/enable', message, { root:true })

    })
  },

  getDeactivateOccupationPermission({ commit, dispatch }, occupation) {
    return getDeactivateOccupationPermission(occupation.id, { entity_id: occupation.entity_id })
    .then(response => response)
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  },

  getDestroyOccupationPermission({ commit, dispatch }, occupation) {
    return getDestroyOccupationPermission(occupation.id)
    .then(response => response)
    .catch(error => {
      store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
    })
  }
}

export const getters = {
  occupationList: state => state.occupationList,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/occupations.js